module.exports = __webpack_public_path__ + "img/img_start_2.b15ebd80.png";